import { Card, Grid, Typography } from "@material-ui/core";

const ServicesIntro = () => {
  return (
    <div style={{ marginTop: '-10px' }}>
      <Card style={{ padding: '20px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">
              Castaneda Tacos & Restaurant is proud to serve our local area which includes Goshen, Elkhart County, Kosciousko County, Noble County, and LaGrange County, IN.
            </Typography>
            <Typography variant="body1">
              We are currently offering dine-in and takeout orders.
            </Typography>
            <Typography variant="body1">
              <b>Languages spoken:</b> English, Spanish.
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default ServicesIntro;
